/**
 * Atom – TaskTag
 * Small removable chip for a single task string.
 * When onRemove is not provided it renders as read-only.
 */
import React from 'react';
import { MdClose } from 'react-icons/md';

const TaskTag = ({ task, onRemove }) => (
  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-accent-green/10 text-accent-green border border-accent-green/25 transition-all duration-150 hover:bg-accent-green/20">
    {task}
    {onRemove && (
      <button
        type="button"
        onClick={() => onRemove(task)}
        className="flex-shrink-0 hover:text-accent-terracotta transition-colors"
        aria-label={`Remove task: ${task}`}
      >
        <MdClose size={12} />
      </button>
    )}
  </span>
);

export default TaskTag;
